module.exports = __webpack_public_path__ + "social.0b3b7acb.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/media/photos/social.png
// module id = 462
// module chunks = 0